import { createReducer, on } from "@ngrx/store";
import * as productsActions from './list-actions';
import * as fromProducts from './list-state';
import { ProductPagedResponse } from "../../_models/product.interface";
import { ProductProviderEnum } from "@app/marketplace/core/enum/productProvider";

const initialState: fromProducts.State = {
  isLoading:false,
  payload:{filter: {sortingArgs: 0},pageSize:8},
  data:{
    count:0,
    totalCount:0,
    configuration:{
      priceFilter:{
        minValue:0,
        maxValue:10,
        step:10,
      }
    }
  } as ProductPagedResponse};
export const reducer = createReducer(
  initialState,
  on(productsActions.LoadingProductsAction, (state,data) => {
    return {...state,isLoading:true,payload:data.payload}
  }),
  on(productsActions.ListProductsAction, (state,{data,provider,scroll}) => {

    switch (true)
     {
      case provider>=2:
      {
        if(!scroll){
          state.data.data=[];
          state.data.count=0;
        }
        if(state.data.count>0){
          if(state.data.data[0].provider>=2){
            //state.data.data = [...state.data.data,...data.data];
            state.data.data = state.data.data.concat(data.data);
            state.data.count+=data.count;
            return {...state,isLoading:false};
          }
          return {...state,isLoading:false,data};
        }
        return {...state,isLoading:false,data};
      }
      default:
        return {...state,isLoading:false,data};
    }
  }),
  on(productsActions.ErrorProductsAction, (state) => {
    return {...state, isLoading: false};
  }),
  on(productsActions.CancelProductRequestAction, (state) => {
    return {...state, isLoading: false};
  }),
);

/* export function productReducer(state: fromProducts.State, action: Action) {
  return reducer(state, action);
} */
